<template lang="html">
  <div class="documents">
    <Navbar />
    <router-view :key="this.$route.name"></router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Helper_Components/Footer'
import { mapGetters } from 'vuex'

export default {
  name: 'documents',
  components:{
    Navbar,
    Footer
  },
  computed:{
      ...mapGetters(['allTemplateDetails'])
  }
}
</script>

<style lang="css" scoped>
</style>
